import React, { ComponentType, FC } from 'react';
import { Location, useLocation, useNavigate, useParams } from 'react-router-dom';

/**
 * Interface for router props
 * Match the exact v5 router props
 * @deprecated use useLocation, useNavigate, useParams instead
 */
export interface WithRouterProps {
    history: {
        push: (path: string, state?: any) => void;
        replace: (path: string, state?: any) => void;
        go: (n: number) => void;
        goBack: () => void;
        goForward: () => void;
        location: Location;
    };
    location: Location;
    match: {
        params: Record<string, string>;
        isExact: boolean;
        path: string;
        url: string;
    };
}

// Custom hook that returns router props
export function useRouter(): WithRouterProps {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const match = {
        params,
        isExact: true, // In v6 this concept is handled differently
        path: location.pathname,
        url: location.pathname,
    };

    const history = {
        push: (path: string, state?: any) => navigate(path, { state }),
        replace: (path: string, state?: any) => navigate(path, { replace: true, state }),
        go: (n: number) => navigate(n),
        goBack: () => navigate(-1),
        goForward: () => navigate(1),
        location,
    };

    return {
        history,
        location,
        match,
    };
}

/**
 * HOC to replicate withRouter interface from React Router v5
 * @deprecated use useLocation, useNavigate, useParams instead
 * @param Component
 */
export function withRouter<P extends WithRouterProps>(
    Component: ComponentType<P>
): FC<Omit<P, keyof WithRouterProps>> {
    return function WithRouterWrapper(props) {
        const routerProps = useRouter();
        return <Component {...(props as P)} {...routerProps} />;
    };
}
